var React = require('react');

function Reorder (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{"id":"Layer_1"},React.createElement("g",null,[React.createElement("path",{"d":"M55,98.9c-15.8,0-28.8-11.6-32.6-28.7l5.8,4.7-.6-6.4-8.2-6.7-6.7,8.2.6,6.4,5.1-6.2c3.9,19.4,18.6,32.7,36.6,32.7s36.6-17.2,37.6-41l-4-.2c-.9,21.5-15.1,37.2-33.7,37.2Z","key":0}),React.createElement("path",{"d":"M55,5.6c14.5,0,27.1,18.8,31.7,38.1l-6.2-4.4,1,6.3,8.6,6.2,6.2-8.6-1-6.3-4.7,6.5C85.9,22.6,72.2,1.6,55,1.6S20.6,27.4,17.7,51.6l4,.5C25,24.3,41.6,5.6,55,5.6Z","key":1})]))));
}

Reorder.defaultProps = {"version":"1.1","viewBox":"0 0 110 104.4"};

module.exports = Reorder;

Reorder.default = Reorder;
